import React from 'react';
import SignInForm from '../../components/form/SignInForm';

const SignInPage: React.FC = () => {
  return <SignInForm />;
};

export default SignInPage;
